import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupDCT from "../FieldTags/GroupDCT";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const ValidationNotesText = ({ validationNotesText, handleChange, pullLists, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal }) => {
    const { user } = useContext(UserContext);
    const canEdit = ((shipmentFromRepo === "No" && sampleDisposal === "No") || (informedConsent !== "No" && informedConsentApprover !== "No")) && checkRole(user, [ROLES.DCT]);

    return (
        <div className="planField">
            <GroupDCT />
            <TextField
                id="validationNotesText-field"
                name="validationNotesText"
                label={pullListLabels.validationNotesText}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={validationNotesText ? validationNotesText : ""}
                onChange={(e) => handleChange("validationNotesText", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"validationNotesText"} />
        </div>
    );
};

export default ValidationNotesText;